import { render, staticRenderFns } from "./RegisterPayment.vue?vue&type=template&id=ffd2256e&"
import script from "./RegisterPayment.vue?vue&type=script&lang=js&"
export * from "./RegisterPayment.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPayment.vue?vue&type=style&index=0&id=ffd2256e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports